export const ERROR_CODE = 200;
const apiUrl = process.env.REACT_APP_BACKEND_URL;


const handleResponse = async (response) => {
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return await response.json();
};


// API CALLS

export const getCustomersList = async () => {
  const requestOptions = {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  };

  try {
    const res = await fetch(`${apiUrl}users/dropdown/customers`, requestOptions);
    const data = await handleResponse(res);
    const usernames = data.map(customer => customer.username);
    return data;
  } catch (err) {
    console.error('getCustomersForUser error:', err);
    return ERROR_CODE;
  }
};

export const getBuildingsForUser = async (customerId = null) => {
  const url = customerId
    ? `${apiUrl}users/dropdown/buildings/${customerId}`
    : `${apiUrl}users/dropdown/buildings`;

  const requestOptions = {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  };

  try {
    const res = await fetch(url, requestOptions);
    return await handleResponse(res);
  } catch (err) {
    console.error('getBuildingsForUser error:', err);
    return ERROR_CODE;
  }
};

export const getFloorsForBuilding = async (buildingId) => {
  const requestOptions = {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  };

  try {
    const res = await fetch(`${apiUrl}users/dropdown/floors/${buildingId}`, requestOptions);
    return await handleResponse(res);
  } catch (err) {
    console.error('getFloorsForBuilding error:', err);
    return ERROR_CODE;
  }
};

export const getAreaSize = async (building_id, floor_num = null) => {
  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      building_id: building_id,
      floor_num: floor_num
    })
  };

  try {
    const res = await fetch(`${apiUrl}api/buildings/area-size`, requestOptions);
    return await handleResponse(res);
  } catch (err) {
    console.error('getAreaSize error:', err);
    return ERROR_CODE;
  }
};

// FILTER API CALLS WITH DATA TRANSFORMATION 
//[{ value: 'all', label: 'All Customers' }]
export const getDistributors = async () => {
  const requestOptions = {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  };

  try {
    const res = await fetch(`${apiUrl}api/buildings/distributors`, requestOptions);
    const rawData = await handleResponse(res);

    // Data transformation happens here
    if (!Array.isArray(rawData)) {
      // console.log(' getDistributors: Invalid data format, expected array');
      return { success: false, error: 'Invalid data format', options: [] };
    }

    const formattedOptions = [
      //{ value: 'all', label: 'All Distributors' },
      ...rawData.map(d => ({
        value: d.id.toString(),
        label: d.username || `${d.first_name || ''} ${d.last_name || ''}`.trim() || d.name || `User ${d.id}`,
        username: d.username,
        firstName: d.first_name,
        lastName: d.last_name,
      }))
    ];

    // console.log('✅ getDistributors: Success -', formattedOptions.length - 1, 'distributors loaded');
    return { success: true, options: formattedOptions, raw: rawData };

  } catch (err) {
    console.error('❌ getDistributors error:', err);
    return { success: false, error: err.message, options: [] };
  }
};

export const getDistributorCustomers = async (distId) => {
  const requestOptions = {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  };

  try {
    const res = await fetch(`${apiUrl}api/buildings/customers/${distId}`, requestOptions);
    const rawData = await handleResponse(res);

    // ✅ Data transformation happens here
    if (!Array.isArray(rawData)) {
      // console.log('⚠️ getDistributorCustomers: Invalid data format, expected array');
      return { success: false, error: 'Invalid data format', options: []//[{ value: 'all', label: 'All Customers' }] 
    };
    }

    const formattedOptions = [
//      { value: 'all', label: 'All Customers' },
      ...rawData.map(c => ({
        value: c.id.toString(),
        label: c.username || `${c.first_name || ''} ${c.last_name || ''}`.trim() || c.name || `Customer ${c.id}`,
        username: c.username,
        firstName: c.first_name,
        lastName: c.last_name,
      }))
    ];

    // console.log('✅ getDistributorCustomers: Success -', formattedOptions.length - 1, 'customers loaded for distributor', distId);
    return { success: true, options: formattedOptions, raw: rawData };

  } catch (err) {
    console.error('❌ getDistributorCustomers error:', err);
    return { success: false, error: err.message, options: [],//[{ value: 'all', label: 'All Customers' }] 
    };
  }
};

export const getCustomerBuildings = async (customerId) => {
  const requestOptions = {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  };

  try {
    const res = await fetch(`${apiUrl}api/buildings/customer-buildings/${customerId}`, requestOptions);
    const rawData = await handleResponse(res);

    // ✅ Data transformation happens here
    if (!Array.isArray(rawData)) {
      console.log('⚠️ getCustomerBuildings: Invalid data format, expected array');
      return { success: false, error: 'Invalid data format', options:[] //[{ value: 'all', label: 'All Buildings' }] 
      };
    }

    const formattedOptions = [
      //{ value: 'all', label: 'All Buildings' },
      ...rawData.map(b => ({
        value: b.id.toString(),
        label: b.address ? `${b.name} - ${b.address}` : (b.city ? `${b.name} - ${b.city}` : b.name),
        name: b.name,
        address: b.address,
        city: b.city,
        street: b.street,
      }))
    ];

    console.log('✅ getCustomerBuildings: Success -', formattedOptions.length - 1, 'buildings loaded for customer', customerId);
    return { success: true, options: formattedOptions, raw: rawData };

  } catch (err) {
    console.error('❌ getCustomerBuildings error:', err);
    return { success: false, error: err.message, options: []//[{ value: 'all', label: 'All Buildings' }] 
  };
  }
};

export const getBuildingFloors = async (buildingId) => {
  const requestOptions = {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  };

  try {
    const res = await fetch(`${apiUrl}api/buildings/floors/${buildingId}`, requestOptions);
    const rawData = await handleResponse(res);

    // ✅ Data transformation happens here
    if (!Array.isArray(rawData)) {
      console.log('⚠️ getBuildingFloors: Invalid data format, expected array');
      return { success: false, error: 'Invalid data format', options: [{ value: 'all', label: 'All Floors' }] };
    }

    const formattedOptions = [
      { value: 'all', label: 'All Floors' },
      ...rawData.map(f => ({
        value: f.floor_number ? f.floor_number.toString() : f.value,
        label: f.floor_number ? `Floor ${f.floor_number}` : f.label || `Floor ${f.value}`,
        floor_number: f.floor_number || f.value,
      }))
    ];

    console.log('✅ getBuildingFloors: Success -', formattedOptions.length - 1, 'floors loaded for building', buildingId);
    return { success: true, options: formattedOptions, raw: rawData };

  } catch (err) {
    console.error('❌ getBuildingFloors error:', err);
    return { success: false, error: err.message, options: [{ value: 'all', label: 'All Floors' }] };
  }
};

export const getBuildingAreas = async (buildingIds) => {
  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ buildingIds }),
  };

  try {
    const res = await fetch(`${apiUrl}api/buildings/areas`, requestOptions);
    const rawData = await handleResponse(res);

    // ✅ Data transformation happens here
    if (!Array.isArray(rawData)) {
      console.log('⚠️ getBuildingAreas: Invalid data format, expected array');
      return { success: false, error: 'Invalid data format', options: [{ value: 'all', label: 'All Areas' }] };
    }

    const formattedOptions = [
      { value: 'all', label: 'All Areas' },
      ...rawData.map(a => ({
        value: a.id.toString(),
        label: a.building_name ? `${a.name} (${a.building_name})` : a.name,
        name: a.name,
        floor_number: a.floor_number || a.floor,
        building_name: a.building_name,
        building_id: a.building_id,
      }))
    ];

    console.log('✅ getBuildingAreas: Success -', formattedOptions.length - 1, 'areas loaded for buildings', buildingIds);
    return { success: true, options: formattedOptions, raw: rawData };

  } catch (err) {
    console.error('❌ getBuildingAreas error:', err);
    return { success: false, error: err.message, options: [{ value: 'all', label: 'All Areas' }] };
  }
};

export const getFilteredSensors = async ({ buildingIds, filters = {} }) => {
  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ buildingIds, filters }),
  };

  try {
    const res = await fetch(`${apiUrl}api/buildings/sensors`, requestOptions);
    const rawData = await handleResponse(res);

    // ✅ Data transformation happens here
    if (!Array.isArray(rawData)) {
      console.log('⚠️ getFilteredSensors: Invalid data format, expected array');
      return { success: false, error: 'Invalid data format', sensors: [], count: { total: 0, active: 0 } };
    }

    const sensorsCount = {
      total: rawData.length,
      active: rawData.filter(s => s.status !== 4 && s.status !== 'inactive').length
    };

    console.log('✅ getFilteredSensors: Success -', sensorsCount.total, 'sensors loaded,', sensorsCount.active, 'active');
    return { success: true, sensors: rawData, count: sensorsCount, raw: rawData };

  } catch (err) {
    console.error('❌ getFilteredSensors error:', err);
    return { success: false, error: err.message, sensors: [], count: { total: 0, active: 0 } };
  }
};

// static status DROPDOWN
export const getStatusOptions = () => {
  return [
    { value: 'all', label: 'All' },
    { value: '1', label: 'Good' },
    { value: '2', label: 'Moderate' },
    { value: '3', label: 'Bad' },
    { value: '4', label: 'Inactive' },
  ];
};